import { userState } from '@/stores/user'

class BarkerAuth {
  #ID = '_barker_id'
  #TOKEN = '_barker_token'
  #ORGANIZATION = '_barker_organization'
  #STATE = '_barker_state'

  login(user){
    localStorage.setItem(this.#ID, user.username)
    localStorage.setItem(this.#TOKEN, user.token)
    localStorage.setItem(this.#ORGANIZATION, JSON.stringify(user.organization))
    barkerAuth.syncUserState()
  }
  // Update reactive state from localstorage.
  syncUserState(){
    if(userState){
      Object.assign(userState, {
        username: barkerAuth.getUsername(),
        organization: barkerAuth.getOrganization(),
        state: barkerAuth.getState(),
      })
      //console.info("synced user state", JSON.parse(JSON.stringify(userState)))//debug
    }
  }
  // Remove auth details. Leave state properties.
  logout(){
    localStorage.removeItem(this.#ID)
    localStorage.removeItem(this.#TOKEN)
    localStorage.removeItem(this.#ORGANIZATION)
    barkerAuth.syncUserState()
  }
  getOrganization(){
    try{
      const organization = JSON.parse(localStorage.getItem(this.#ORGANIZATION))
      organization.config = JSON.parse(organization.config)
      return organization
    } catch (e) {
      //console.log(`organization not available: ${e}`)
      return null
    }
  }
  getState(){
    const stateJSON = localStorage.getItem(this.#STATE)
    try{
      return JSON.parse(stateJSON) || {}
    } catch (e) {
      return {}
    }
  }
  getUsername(){
    return localStorage.getItem(this.#ID)
  }
  isLoggedIn(){
    try {
      return localStorage.getItem(this.#TOKEN).match(/[0-9a-f]*/)[0] ==
        localStorage.getItem(this.#TOKEN) &&
        localStorage.getItem(this.#ID) != null
    } catch(e) {
      if(e instanceof TypeError){
        // ignore
      } else {
        console.log(e)
      }
    }
    return false
  }
  getToken(){
    return localStorage.getItem(this.#TOKEN)
  }
  // Set and synchronize state.
  setState(state){
    localStorage.setItem(this.#STATE, JSON.stringify(state))
    userState.state = barkerAuth.getState()
  }
   // Set the value of a state property.
   // These are accessible via userState.state.(name)
  setStateProperty(property, value){
    const state = barkerAuth.getState()
    state[property] = value
    this.setState(state)
  }
}

const barkerAuth = new BarkerAuth

export default barkerAuth
